import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationUserCardTemplateDb = {
  userId: string;
  cardTemplateId: string;
}
const initial: RelationUserCardTemplateDb = {
  userId: '',
  cardTemplateId: ''
};

export type RelationUserCardTemplateDbHashType = {
  [key in string]: RelationUserCardTemplateDb;
}

export type RelationUserCardTemplateAddPayload = {
  id?: string;
} & RelationUserCardTemplateDb;
export type RelationUserCardTemplateUpdatePayload = {
  id: string;
} & { [P in keyof RelationUserCardTemplateDb]?: RelationUserCardTemplateDb[P] };

export type RelationUserCardTemplateDbState = {
  relationUserCardTemplates: RelationUserCardTemplateDbHashType;
}

export const  generateRelationUserCardTemplateId = (): string =>  generateId('ruct');
let initialState: RelationUserCardTemplateDbState = { relationUserCardTemplates: {} };
const key = 'relationUserCardTemplates';

const relationUserCardTemplateDbSlice = createSlice({
  name: 'relationUserCardTemplateDb',
  initialState,
  reducers: {
    initializeRelationUserCardTemplates(state: RelationUserCardTemplateDbState) {
      state.relationUserCardTemplates = {};
    },
    addRelationUserCardTemplate(state: RelationUserCardTemplateDbState, action: PayloadAction<RelationUserCardTemplateAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationUserCardTemplateId();
      state.relationUserCardTemplates[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationUserCardTemplate(state: RelationUserCardTemplateDbState, action: PayloadAction<RelationUserCardTemplateUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationUserCardTemplates[id] === undefined) {
        console.log(`*** RelationUserCardTemplate not found: ${id}`);
      } else {
        const newData = { ...state.relationUserCardTemplates[id], ...obj };
        state.relationUserCardTemplates[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationUserCardTemplate(state: RelationUserCardTemplateDbState, action: PayloadAction<RelationUserCardTemplateUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationUserCardTemplates[id];
      deleteData(key, id);
    },
    saveRelationUserCardTemplates(state: RelationUserCardTemplateDbState) {
      saveAllData(key, state.relationUserCardTemplates);
    },
    signUpRelationUserCardTemplates(state: RelationUserCardTemplateDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationUserCardTemplates, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationUserCardTemplateDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationUserCardTemplates = updatedValues;
      if (changed) saveAllData(key, state.relationUserCardTemplates);
    })
  }
})

export const { initializeRelationUserCardTemplates, addRelationUserCardTemplate, updateRelationUserCardTemplate, deleteRelationUserCardTemplate, saveRelationUserCardTemplates, signUpRelationUserCardTemplates } = relationUserCardTemplateDbSlice.actions;
export default relationUserCardTemplateDbSlice.reducer;
